// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export interface ProgramCourseMetadata {
  isExclusive: boolean;
  isSelectedForCredit: boolean;
  isAutoEnrollmentEnabled: boolean;
  courseId: string;
}

export interface ProgramProductMetadataTypeCourse {
  typeName: 'course';
  definition: ProgramCourseMetadata;
}

export interface ProgramProductMetadataTypeSpecialization {
  typeName: 'specialization';
  definition: any;
}

export type ProgramProductMetadataType = ProgramProductMetadataTypeCourse | ProgramProductMetadataTypeSpecialization;

export type ProgramProductMetadataTypeTypeName = 'course' | 'specialization';

export interface ProgramProductMetadataV1 {
  id: string;
  programId: string;
  productType: string;
  productItemId: string;
  metadataType: ProgramProductMetadataType;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface ProgramProductMetadataV1Connection {
  elements: Array<ProgramProductMetadataV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface ProgramProductMetadataV1GetQuery {
  ProgramProductMetadataV1: {
    get: ProgramProductMetadataV1Connection | null;
  } | null;
}

export interface ProgramProductMetadataV1GetQueryVariables {
  id: string;
  includes?: string | null;
}

export interface ProgramProductMetadataV1MultiGetQuery {
  ProgramProductMetadataV1: {
    multiGet: ProgramProductMetadataV1Connection | null;
  } | null;
}

export interface ProgramProductMetadataV1MultiGetQueryVariables {
  ids: string;
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class ProgramProductMetadataV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'programProductMetadata.v1' as const;

  declare id: string;

  declare programId: string;

  declare productType: string;

  declare productItemId: string;

  declare metadataType: ProgramProductMetadataType;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<ProgramProductMetadataV1>) {
    super(params);
  }
}
